Wee.fn.make('carousel', {
	init: function(options) {
		var scope = this,
			config = $.extend({
				arrows: false
			}, options);

		scope.$slideElements = $('ref:' + config.elementRef);
		scope.$parent = this.$slideElements.parent();

		$($._win).on('resize.carousel init', function() {
			scope.calculateWidths();
			scope.setupThumbs(config);
			scope.toggleArrows(config.arrows);
		});

		if (config.arrows) {
			var $arrows = $('ref:' + config.arrows),
				disabledClass = '-is-disabled';

			scope.$leftArrow = $arrows.first();
			scope.$rightArrow = $arrows.last();

			scope.$leftArrow.on('click.carousel', function() {
				if (! scope.$leftArrow.hasClass(disabledClass)) {
					scope.move('left');
				}
			});

			scope.$rightArrow.on('click.carousel', function() {
				if (! scope.$rightArrow.hasClass(disabledClass)) {
					scope.move('right');
				}
			});
		}
	},

	unload: function() {
		$.events.off(false, '.carousel');
	},

	setupThumbs: function() {
		if (this.overflow) {
			var $thumbs = $('ref:thumb');

			this.thumbWidth = $thumbs.width() +
				(parseInt($thumbs.css('margin-left').replace('px', '')) +
				parseInt($thumbs.css('margin-right').replace('px', '')));
		}

		$('ref:thumbsWrap').css('left', '0px');
	},

	calculateWidths: function() {
		var $thumbs = $('ref:thumbs');

		if ($thumbs.length) {
			this.totalWidth = $('ref:thumbsWrap').width();
			this.containerWidth = $thumbs.width();
			this.overflow = this.totalWidth > this.containerWidth;
		}
	},

	move: function(action) {
		var $wrapper = $('ref:thumbsWrap'),
			wrapLeft = $('ref:thumbsWrap').position().left,
			remaining;

		if (action === 'right') {
			remaining = this.totalWidth - this.containerWidth + wrapLeft;

			if (remaining > 0) {
				var minLeft = (this.totalWidth - this.containerWidth) * -1;

				$wrapper.css('left', Math.max(minLeft, (wrapLeft - this.thumbWidth)) + 'px');
			}
		} else {
			$wrapper.css('left', Math.min(0, (wrapLeft + this.thumbWidth)) + 'px');
		}
	},
	toggleArrows: function(name) {
		var $arrows = $('ref:' + name);

		this.overflow ? $arrows.show() : $arrows.hide();
	}
});